import styled from 'academy-common-lib/utils/Styling';
import TrackViewAwardLink from '../../../components/TrackCard/TrackViewAwardLink';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
const NoWrapTrackViewAwardLink = styled(TrackViewAwardLink).withConfig({
  displayName: "LearningContentCardAwardLink__NoWrapTrackViewAwardLink"
})(["white-space:nowrap;margin-left:18px;margin-bottom:1px;"]);
export const LearningContentCardAwardLink = ({
  award,
  use = 'on-dark'
}) => {
  if (!award || award.isExpired) return null;
  return /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(NoWrapTrackViewAwardLink, {
      award: award,
      certification: true,
      likeLink: true,
      trackId: award.trackIdAward,
      use: use,
      useButton: false
    })
  });
};
export default LearningContentCardAwardLink;